import React, { useContext } from "react";
import { CreateArtifactContext } from "../../../../../context/CreateArtifactContext";
import { ContentState } from "../../../../../models/SKArtifact";
import { isEditable } from "@testing-library/user-event/dist/utils";
import { normalizeURL } from "../../../../../utils/stringFunctions";

interface Item {
  id: string;
  listImage: string;
  listTitle: string;
  listURL: string;
}

interface LayoutCoulmnInputProps {
  items: Item[];
  editItemPopup: (id: string) => void;
  handleRemoveItem: (id: string) => void;
}

export const LayoutCoulmnInput = ({ items, editItemPopup, handleRemoveItem }: LayoutCoulmnInputProps) => {
  const { contentData, isEditable } = useContext(CreateArtifactContext);

  // Calculate the aspect ratio of the image
  const getAspectRatio = (imagePreview: string) => {
    if (imagePreview) {
      const img = new Image();
      img.src = imagePreview;
      return img.naturalWidth / img.naturalHeight;
    }
    return 1;
  };

  return (
    <div className="w-full">
      {items.map((item, index) => (
        <div className="gap-[5px] border-skseparatorgray rounded-md p-[15px] flex flex-row">
          <div key={index} className="flex flex-col ">
            <div className="flex-shrink-0">
              <div className="relative p-1 border-2 border-gray-200 rounded-md overflow-hidden w-full h-full max-w-[500px] max-h-[500px]">
                <img src={item.listImage} alt={item.listTitle} className="object-cover w-full h-full" />
              </div>
            </div>

            <div className="flex flex-row mt-[15px]">
              <div className="flex flex-col w-4/5">
                <div className="text-lg font-bold list_item_title">{item.listTitle}</div>
                <div className="text-gray-500 list_item_sub_title">
                  <a href={normalizeURL(item.listURL)} target="_blank" rel="noopener noreferrer" className="underline hover:text-gray-700">
                    {item.listURL}
                  </a>
                </div>
              </div>

              <div className="flex flex-row w-1/5">
                {isEditable && (
                  <div className="flex flex-col gap-[5px] ml-auto  mr-[5px] mt-[5px]">
                    <button
                      className="flex items-center justify-center w-5 h-5 text-white rounded-full shadow-md bg-slate-600"
                      onClick={() => handleRemoveItem(item.id)}
                    >
                      ×
                    </button>
                    <button
                      className="flex items-center justify-center w-5 h-5 text-white rounded-full shadow-md bg-slate-600"
                      onClick={() => editItemPopup(item.id)}
                    >
                      ✎
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
